import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { LocationCard } from 'components/program-marketing/location-card'

const useStyles = makeStyles(theme => ({
  list: {
    paddingLeft: theme.spacing(2),
    height: '100%',
  },
}))

export const WhatsIncluded = ({ requirements }) => {
  const classes = useStyles()
  return (
    <LocationCard title="What's Included">
      <ul className={classes.list}>
        {requirements.map((point, index) => (
          <li key={index}>
            <Typography component="span" variant="body1">
              {point}
            </Typography>
          </li>
        ))}
      </ul>
    </LocationCard>
  )
}

WhatsIncluded.propTypes = {
  points: PropTypes.arrayOf(PropTypes.string),
}
